module.exports = __webpack_public_path__ + "img/lead_slide2_lg.4e993067.png";